import Joi from "@hapi/joi";

const modelVersionSchema = Joi.object({
  country: Joi.string().required(),
  versions: Joi.array().required().items(Joi.string().max(100)),
  _id: Joi.string(),
});

export const modelSchema = Joi.object({
  name: Joi.string().required().max(100),
  url: Joi.string().required(),
  countries: Joi.array().required().min(1).items(modelVersionSchema),
  created_by: Joi.string().required(),
  headers: Joi.array().required(),
});
